var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickInCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tick-in-circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Work-order",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MVP-Home-Page---multiple-passes-approved",
    transform: "translate(-32.000000, -273.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-in-circle",
    transform: "translate(32.000000, 273.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 Z M10,18.1818182 C5.48130659,18.1818182 1.81818182,14.5186934 1.81818182,10 C1.81818182,5.48130659 5.48130659,1.81818182 10,1.81818182 C14.5186934,1.81818182 18.1818182,5.48130659 18.1818182,10 C18.1818182,14.5186934 14.5186934,18.1818182 10,18.1818182 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41275801,12.1948737 L7.03059343,10.7026115 C6.68941975,10.3342613 6.11423698,10.3122303 5.74588677,10.653404 C5.37753655,10.9945776 5.35550563,11.5697605 5.6966793,11.9381106 L7.14820439,13.5052585 C7.79953596,14.2084725 8.89761214,14.2505315 9.60082618,13.5991999 C9.68985845,13.5167365 9.769996,13.4251622 9.83992382,13.3259802 L14.3793548,6.8874783 C14.6686647,6.4771356 14.5705483,5.90995508 14.1602055,5.62064517 C13.7498629,5.33133526 13.1826824,5.42945173 12.8933725,5.83979443 L8.41275801,12.1948737 Z",
    id: "Path-2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickInCircle);
export default __webpack_public_path__ + "static/media/TickInCircle.adb5dfc28af402f9ebbc803c6d603a65.svg";
export { ForwardRef as ReactComponent };